/**
 * Sensitive query params currently known to appear in Milanote URLs or telemetry.
 */
export const MONITORING_SCRUB_QUERY_PARAMS = [
    // Reassess whether `code` should be scrubbed without losing useful error codes in monitoring.
    // See https://linear.app/milanote/issue/WEB-16373/reassess-monitoring-scrubbing-for-code-query-params
    // 'code',
    'p',
    'p_tokens',
    'token',
    'tokens',
];

/**
 * Sensitive header names that should not be exposed in monitoring payloads.
 */
const MONITORING_SCRUB_HEADER_FIELDS = ['authorization', 'cookie', 'set-cookie'];

/**
 * Sensitive auth field names that can appear in payload objects outside URL/header contexts.
 */
const MONITORING_SCRUB_AUTH_FIELDS = ['access_token', 'id_token', 'refresh_token', 'auth'];

/**
 * Sensitive fields that may show up in log data payloads that should be scrubbed, such as content fields that may contain user-generated data.
 */
const MONITORING_SCRUB_DATA_FIELDS = [
    'content', // User entered content in a board element
];

/**
 * Shared monitoring scrub field names for tools that need to redact sensitive auth or permission
 * data from payloads, including object keys, header names, and matching query params.
 */
export const MONITORING_SCRUB_FIELDS: string[] = [
    ...new Set([
        ...MONITORING_SCRUB_QUERY_PARAMS,
        ...MONITORING_SCRUB_HEADER_FIELDS,
        ...MONITORING_SCRUB_AUTH_FIELDS,
        ...MONITORING_SCRUB_DATA_FIELDS,
    ]),
];
